export interface PFIClientGstProps {
  data: any;
  setData: Function;
}

const PFIClientGst = ({ data }: PFIClientGstProps) => {
  return (
    <div className="mt-3 row align-items-start">
      <div className="col-4">GST No.</div>
      <div className="col-8 d-flex align-items-start" style={{ gap: 4 }}>
        <div>:</div>
        <div className="px-2">{data?.client_gst || "—"}</div>
      </div>
    </div>
  );
};

export default PFIClientGst;
